function onKeyChangeCardText(inputElement, cardElement, select = false) {
  $(document).on("keyup change update click blur", inputElement, function () {
    let value = ($(this).val() || '').trim();
    if (value && value != "") {
      $(cardElement).text(value);
    }
  });
}

const product_id = 44040428421395;

function addToCart(onSccuess = () => {}) {
  $(".card-loader-wrap").css("display", "flex");
  let formData = {
    items: [
      {
        id: product_id,
        quantity: 1,
      },
    ],
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      response.json();
      setTimeout(function () {
        onSccuess();
      }, 500);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

jQuery(function ($) {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("showCart");
  console.log(myParam);
  if (myParam == 1) {
    $("#CartDrawer-Checkout").trigger("click");
  }
  $(window).on("load resize", function (e) {

    $(document).on(
      "keyup change update click blur",
      "#card_form_1 input , #card_form_1 textarea",
      function () {
        let thisName = $(this).attr("name");
        $('.hideForm form input[name="' + thisName + '"]').val($(this).val()),
          $('.hideForm form textarea[name="' + thisName + '"]').val($(this).val());
        var main_phone_num = $("#card_form_1 input[name=card_holder_mobile_number_user_1]").val(),
          country_code = $(".cc_first").text();
        $("#DynamicForm_1 input[name=phone]").val(country_code + " " + main_phone_num);
      }
    ),
    $(document).on(
      "keyup change update click blur",
      "#card_form_2 input , #card_form_2 textarea",
      function () {
        let thisName = $(this).attr("name");
        $('.hideForm form input[name="' + thisName + '"]').val($(this).val()),
          $('.hideForm form textarea[name="' + thisName + '"]').val($(this).val());
      }
    ),
    $(document).on(
      "keyup change update click blur",
      "#card_form_3 input , #card_form_3 textarea",
      function () {
        let thisName = $(this).attr("name");
        $('.hideForm form input[name="' + thisName + '"]').val($(this).val()),
          $('.formThree .hideForm form textarea[name="' + thisName + '"]').val($(this).val());
      }
    ),
    $(document).on(
      "keyup change update click blur",
      "#card_form_4 input , #card_form_4 textarea",
      function () {
        let thisName = $(this).attr("name");
        $('.hideForm form input[name="' + thisName + '"]').val($(this).val()),
          $('.hideForm form textarea[name="' + thisName + '"]').val($(this).val());
        $("#card_form_4 .selected-dial-code").text(),
          $("#card_form_4 .countryNumber").val();
      }
    ),
    $(document).on("change blur", "#card_form_1 select", function () {
      let thisName = $(this).attr("name");
      $('.formOne .hideForm form select[name="' + thisName + '"]').val($(this).val()).change();
    }),
    $(document).on("change blur", "#card_form_2 select", function () {
      let thisName = $(this).attr("name");
      $('.formTwo .hideForm form select[name="' + thisName + '"]').val($(this).val()).change();
    }),
    $(document).on("change blur", "#card_form_3 select", function () {
      let thisName = $(this).attr("name");
      $('.formThree .hideForm form select[name="' + thisName + '"]').val($(this).val()).change();
    }),
    $(document).on("change blur", "#card_form_4 select", function () {
      let thisName = $(this).attr("name");
      $('.formFour .hideForm form select[name="' + thisName + '"]').val($(this).val()).change();
    }),
    $(".two-col-form-left-inner").tsukiSticky({
      stickyParent: ".two-col-form-row",
      topOffset: 70,
    }),
    $(document).on("change blur", "#card_form_1 .country-optionst", function () {
      var strNum = $(".country-optionst").find(":selected").val();
      var after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode").text("+" + after_),
        $(".hideForm input[name=phone__cell_]").val("+" + after_);
    }),
    $(document).on("change blur", "#card_form_1 .country-optionst-1", function () {
      var em_num1 = $("input[name=emergency_contact_person_1_number_user_1]").val(),
        strNum = $(".country-optionst-1").find(":selected").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-1").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_1_num_user_1]").val("+" + after_ + " " + em_num1);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_1 input[name=emergency_contact_person_1_number_user_1]",
      function () {
        var em_num1 = $("input[name=emergency_contact_person_1_number_user_1]").val(),
          strNum = $(".country-optionst-1").find(":selected").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-1").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_1_num_user_1]").val("+" + after_ + " " + em_num1);
      }
    ),
    $(document).on("change blur", "#card_form_1 .country-optionst-2", function () {
      var strNum = $(".country-optionst-2").find(":selected").val(),
        em_num2 = $("input[name=emergency_contact_person_2_number]").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-2").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_2_num]").val("+" + after_ + " " + em_num2);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_1 input[name=emergency_contact_person_2_number]",
      function () {
        var strNum = $(".country-optionst-2").find(":selected").val(),
          em_num2 = $("input[name=emergency_contact_person_2_number]").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-2").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_2_num]").val("+" + after_ + " " + em_num2);
      }
    ),
    $(document).on("change blur", "#card_form_2 .country-optionst-3", function () {
      var strNum = $(".country-optionst-3").find(":selected").val(),
        em_num3 = $("input[name=emergency_contact_person_1_number_user_2]").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-3").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_1_num_user_2]").val("+" + after_ + " " + em_num3);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_2 input[name=emergency_contact_person_1_number_user_2]",
      function () {
        var strNum = $(".country-optionst-3").find(":selected").val(),
          em_num3 = $("input[name=emergency_contact_person_1_number_user_2]").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-3").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_1_num_user_2]").val("+" + after_ + " " + em_num3);
      }
    ),
    $(document).on("change blur", "#card_form_2 .country-optionst-4", function () {
      var strNum = $(".country-optionst-4").find(":selected").val(),
        em_num4 = $("input[name=mobile_number_person_2_user_2]").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-4").text("+" + after_),
        $(".hideForm input[name=edit_mobile_num_person_2_user_2]").val("+" + after_ + " " + em_num4);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_2 input[name=mobile_number_person_2_user_2]",
      function () {
        var strNum = $(".country-optionst-4").find(":selected").val(),
          em_num4 = $("input[name=mobile_number_person_2_user_2]").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-4").text("+" + after_),
          $(".hideForm input[name=edit_mobile_num_person_2_user_2]").val("+" + after_ + " " + em_num4);
      }
    ),
    $(document).on("change blur", "#card_form_3 .country-optionst-5", function () {
      var strNum = $(".country-optionst-5").find(":selected").val(),
        em_num5 = $("input[name=emergency_contact_person_1_number_user_3]").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-5").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_1_num_user_3]").val("+" + after_ + " " + em_num5);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_3 input[name=emergency_contact_person_1_number_user_3]",
      function () {
        var strNum = $(".country-optionst-5").find(":selected").val(),
          em_num5 = $("input[name=emergency_contact_person_1_number_user_3]").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-5").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_1_num_user_3]").val("+" + after_ + " " + em_num5);
      }
    ),
    $(document).on("change blur", "#card_form_3 .country-optionst-6", function () {
      var strNum = $(".country-optionst-6").find(":selected").val(),
        em_num6 = $("input[name=emergency_contact_person_2_number_user_3]").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-6").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_2_num_user_3]").val("+" + after_ + " " + em_num6);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_3 input[name=emergency_contact_person_2_number_user_3]",
      function () {
        var strNum = $(".country-optionst-6").find(":selected").val(),
          em_num6 = $("input[name=emergency_contact_person_2_number_user_3]").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-6").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_2_num_user_3]").val("+" + after_ + " " + em_num6);
      }
    ),
    $(document).on("change blur", "#card_form_4 .country-optionst-7", function () {
      var strNum = $(".country-optionst-7").find(":selected").val(),
        after_ = strNum.substring(strNum.indexOf("+") + 1),
        em_num7 = $("input[name=emergency_contact_person_1_number_user_4]").val();
      $(".countryCode-7").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_1_num_user_4]").val("+" + after_ + " " + em_num7);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_4 input[name=emergency_contact_person_1_number_user_4]",
      function () {
        var strNum = $(".country-optionst-7").find(":selected").val(),
          after_ = strNum.substring(strNum.indexOf("+") + 1),
          em_num7 = $("input[name=emergency_contact_person_1_number_user_4]").val();
        $(".countryCode-7").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_1_num_user_4]").val("+" + after_ + " " + em_num7);
      }
    ),
    $(document).on("change blur", "#card_form_4 .country-optionst-8", function () {
      var strNum = $(".country-optionst-8").find(":selected").val(),
        em_num8 = $("input[name=emergency_contact_person_2_number_user_4]").val();
      var after_ = strNum.substring(strNum.indexOf("+") + 1);
      $(".countryCode-8").text("+" + after_),
        $(".hideForm input[name=emergency_contact_person_2_num_user_4]").val("+" + after_ + " " + em_num8);
    }),
    $(document).on(
      "keyup change update click blur",
      "#card_form_4 input[name=emergency_contact_person_2_number_user_4]",
      function () {
        var strNum = $(".country-optionst-8").find(":selected").val(),
          em_num8 = $("input[name=emergency_contact_person_2_number_user_4]").val();
        var after_ = strNum.substring(strNum.indexOf("+") + 1);
        $(".countryCode-8").text("+" + after_),
          $(".hideForm input[name=emergency_contact_person_2_num_user_4]").val("+" + after_ + " " + em_num8);
      }
    );

    $(document).ready(function () {
      $(".firstname").bind("keypress", function (event) {
        if (event.charCode != 0) {
          var regex = new RegExp("^[a-zA-Z ]+$");
          var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
          if (!regex.test(key)) {
            event.preventDefault();
            return false;
          }
        }
      });

      $("#card_form_1").validate(),
        $("#card_form_2").validate(),
        $("#card_form_3").validate(),
        $("#card_form_4").validate(),
        $(":input").change(function () {
          $(this).val($(this).val().trim());
        });

      $(document).on("click", ".formOne .image-upload-in-form", function () {
        $(".formOne .hs_upload_file input[name=upload_file]").trigger("click");
      }),
      $(document).on("keyup change update click blur", ".formOne .hs_upload_file input[name=upload_file]", function (e) {
        var pathArray = $("input[name=upload_file]").val().split("\\");
        $("#card_form_1 .image-name-text").text(pathArray[pathArray.length - 1]);
      }),
      $(document).on("click", ".formTwo .image-upload-in-form", function () {
        $(".formTwo input[name=upload_file_user_2]").trigger("click");
      }),
      $(document).on("change blur", ".formTwo input[name=upload_file_user_2]", function (e) {
        var pathArray = $("input[name=upload_file_user_2]").val().split("\\");
        $("#card_form_2 .image-name-text").text(pathArray[pathArray.length - 1]);
      }),
      $(document).on("click", ".formThree .image-upload-in-form", function () {
        $(".formThree input[name=upload_file_user_3]").trigger("click");
      }),
      $(document).on("change blur", ".formThree input[name=upload_file_user_3]", function (e) {
        var pathArray = $("input[name=upload_file_user_3]").val().split("\\");
        $("#card_form_3 .image-name-text").text(pathArray[pathArray.length - 1]);
      }),
      $(document).on("click", ".formFour .image-upload-in-form", function () {
        $(".formFour input[name=upload_file_user_4]").trigger("click");
      }),
      $(document).on("change blur", ".formFour input[name=upload_file_user_4]", function (e) {
        var pathArray = $("input[name=upload_file_user_4]").val().split("\\");
        $("#card_form_4 .image-name-text").text(pathArray[pathArray.length - 1]);
      });

      var member_id = "ic" + (+new Date()).toString(36).slice(-3);
      $(".member_id").val(member_id);

      $(document).on("click", "#card_form_1 .addToBag a", function () {
        $("#card_form_1").valid();
        setTimeout(function () {
          if ($("#card_form_1 .hs-input.error").length > 0) {
            $(".formOne form").addClass("is-invalid");
            console.log("Not submit");
          } else {
            console.log("Finally submit");
            $("body").addClass("OpenPopup");
            $(".form-area .two-col-form-right-inner").find(".popUpForm").fadeIn();
          }
        }, 500);
      });

      $(document).on("click", "#card_form_2 .addToBag a", function () {
        $("#card_form_2").valid();
        setTimeout(function () {
          if ($("#card_form_2 .hs-input.error").length > 0) {
            $(".formTwo form").addClass("is-invalid");
            console.log("Not submit");
          } else {
            console.log("Finally submit");
            $("body").addClass("OpenPopup");
            $(".form-area .two-col-form-right-inner").find(".popUpForm").fadeIn();
          }
        }, 500);
      });

      $(document).on("click", "#card_form_3 .addToBag a", function () {
        $("#card_form_3").valid();
        setTimeout(function () {
          if ($("#card_form_3 .hs-input.error").length > 0) {
            $(".formThree form").addClass("is-invalid");
            console.log("Not submit");
          } else {
            console.log("Finally submit");
            $("body").addClass("OpenPopup");
            $(".form-area .two-col-form-right-inner").find(".popUpForm").fadeIn();
          }
        }, 500);
      });

      $(document).on("click", "#card_form_4 .addToBag a", function () {
        $("#card_form_4").valid();
        setTimeout(function () {
          if ($("#card_form_4 .hs-input.error").length > 0) {
            $(".formFour form").addClass("is-invalid");
            console.log("Not submit");
          } else {
            console.log("Finally submit");
            $("body").addClass("OpenPopup");
            $(".form-area .two-col-form-right-inner").find(".popUpForm").fadeIn();
          }
        }, 500);
      });

      // ─── HUBSPOT DIRECT API SUBMISSION ───────────────────────────────────────

      var PORTAL_ID = "8926831";
      var HS_FORM_IDS = {
        1: "9285f21b-127a-49cf-aa3d-79c02cf68281",
        2: "7dfcbb27-3c45-4b37-b980-cb48d85870bd",
        3: "9f15b75b-8ea2-433b-8a51-5847dafcd3a7",
        4: "a0c318e2-329b-4315-b887-94ea14c5b1dc",
      };

      function getFormStep() {
        return +localStorage.getItem("form_step") || 0;
      }

      function getStoredFormData() {
        var raw = localStorage.getItem("form_data");
        return raw ? JSON.parse(raw) : null;
      }

      function collectFormFields(formSelector) {
        var data = {};
        $(formSelector).find("input, select, textarea").each(function () {
          var name = $(this).attr("name");
          var type = $(this).attr("type");
          if (!name) return;
          if (type === "checkbox") {
            data[name] = $(this).is(":checked") ? "true" : "false";
          } else {
            data[name] = $(this).val() || "";
          }
        });
        return data;
      }

      // Normalize form 2/3/4 fields to match form 1 HubSpot field names
      function normalizeFields(fields, formNumber) {
        var f = {};

        if (formNumber === 2) {
          f["firstname"]                             = fields["full_name___user_2"]                                || "";
          f["phone"]                                 = "+1 " + (fields["contact_number_1___user_2"]               || "");
          f["alternate_phone_number_user_1"]         = "+1 " + (fields["contact_number_2_user_2"]                 || "");
          f["rescucitate"]                           = fields["rescucitate_user_2"]                                || "";
          f["blood_type"]                            = fields["blood_type_user_2"]                                 || "";
          f["allergies"]                             = fields["allergies_user_2"]                                  || "";
          f["medications"]                           = fields["medications_user_2"]                                || "";
          f["message"]                               = fields["medical_condition_instructions_other_notes_user_2"] || "";
          f["contact_person_1_name"]                 = fields["emergency_contact_person_1_name_user_2"]            || "";
          f["relation_with_person"]                  = fields["relation_with_person_user_2"]                       || "";
          f["emergency_contact_person_1_num_user_1"] = fields["emergency_contact_person_1_number_user_2"]          || "";
          f["emergency_contact_person_2_name"]       = fields["emergency_contact_person_2_name_user_2"]            || "";
          f["relation_with_person_2"]                = fields["relation_with_person_2_user_2"]                     || "";
          f["emergency_contact_person_2_num"]        = fields["mobile_number_person_2_user_2"]                     || "";
        }

        if (formNumber === 3) {
          f["firstname"]                             = fields["full_name_user_3"]                                  || "";
          f["phone"]                                 = "+1 " + (fields["card_holder_mobile_number_user_3"]         || "");
          f["alternate_phone_number_user_1"]         = "+1 " + (fields["alternate_phone_number_user_3"]            || "");
          f["rescucitate"]                           = fields["rescucitate_user_3"]                                || "";
          f["blood_type"]                            = fields["blood_type_user_3"]                                 || "";
          f["allergies"]                             = fields["allergies_user_3"]                                  || "";
          f["medications"]                           = fields["medications_user_3"]                                || "";
          f["message"]                               = fields["medical_condition_instructions_other_notes_user_3"] || "";
          f["contact_person_1_name"]                 = fields["emergency_contact_person_1_name_user_3"]            || "";
          f["relation_with_person"]                  = fields["relation_with_person_user_3"]                       || "";
          f["emergency_contact_person_1_num_user_1"] = fields["emergency_contact_person_1_number_user_3"]          || "";
          f["emergency_contact_person_2_name"]       = fields["emergency_contact_person_2_name_user_3"]            || "";
          f["relation_with_person_2"]                = fields["relation_with_person_2_user_3"]                     || "";
          f["emergency_contact_person_2_num"]        = fields["emergency_contact_person_2_number_user_3"]          || "";
        }

        if (formNumber === 4) {
          f["firstname"]                             = fields["full_name_user_4"]                                  || "";
          f["phone"]                                 = "+1 " + (fields["contact_number_1_user_4"]                  || "");
          f["alternate_phone_number_user_1"]         = "+1 " + (fields["contact_number_2_user_4"]                  || "");
          f["rescucitate"]                           = fields["rescucitate_user_4"]                                || "";
          f["blood_type"]                            = fields["blood_type_user_4"]                                 || "";
          f["allergies"]                             = fields["allergies_user_4"]                                  || "";
          f["medications"]                           = fields["medications_usre_4"]                                || ""; // note: typo in original form
          f["message"]                               = fields["medical_condition_instructions_other_notes_user_4"] || "";
          f["contact_person_1_name"]                 = fields["emergency_contact_person_1_name_user_4"]            || "";
          f["relation_with_person"]                  = fields["relation_with_person_user_4"]                       || "";
          f["emergency_contact_person_1_num_user_1"] = fields["emergency_contact_person_1_number_user_4"]          || "";
          f["emergency_contact_person_2_name"]       = fields["emergency_contact_person_2_name_user_4"]            || "";
          f["relation_with_person_2"]                = fields["relation_with_person_2_user_4"]                     || "";
          f["emergency_contact_person_2_num"]        = fields["emergency_contact_person_2_number_user_4"]          || "";
        }

        return f;
      }

      function submitToHubSpot(formNumber, extraData, onSuccess, onError) {
        var formId = HS_FORM_IDS[formNumber];
        if (!formId) {
          console.error("No HubSpot form ID for form number", formNumber);
          return;
        }

        var formSelector = "#card_form_" + formNumber;
        var raw = collectFormFields(formSelector);
        var fields;

        if (formNumber === 1) {
          // ── FORM 1: use fields as-is, map phones ────────────────────────────
          fields = raw;
          fields["email"]             = extraData.email || fields["email"] || "";
          fields["member_id_of_user"] = extraData.member_id || "";

          // Main phone → HubSpot "phone" (phone type)
          var cc1 = ($(".cc_first").text() || "+1").trim();
          var ph1 = fields["card_holder_mobile_number_user_1"] || "";
          if (ph1) fields["phone"] = cc1 + " " + ph1;
          delete fields["card_holder_mobile_number_user_1"];

          // Alternate phone (single line text — prepend country code)
          var alt1 = fields["alternate_phone_number_user_1"] || "";
          if (alt1) fields["alternate_phone_number_user_1"] = cc1 + " " + alt1;

          // Emergency contact 1 (text type — rename only)
          var em1 = fields["emergency_contact_person_1_number_user_1"] || "";
          if (em1) fields["emergency_contact_person_1_num_user_1"] = em1;
          delete fields["emergency_contact_person_1_number_user_1"];

          // Emergency contact 2 (text type — rename only)
          var em2 = fields["emergency_contact_person_2_number"] || "";
          if (em2) fields["emergency_contact_person_2_num"] = em2;
          delete fields["emergency_contact_person_2_number"];

        } else {
          // ── FORMS 2-4: normalize all fields to match form 1 field names ─────
          fields = normalizeFields(raw, formNumber);
          var memberId = (extraData && extraData.member_id) ? extraData.member_id : "unknown";
          fields["email"]             = memberId + "_card" + formNumber + "@ironcladfamily-vault.com";
          fields["member_id_of_user"] = memberId;
        }

        // Remove "+1 " prefix if the phone value was empty (avoids sending "+1 " as a value)
        ["phone", "alternate_phone_number_user_1"].forEach(function (k) {
          if (fields[k] && fields[k].trim() === "+1") delete fields[k];
        });

        var hsFields = Object.keys(fields)
          .filter(function (k) { return fields[k] !== ""; })
          .map(function (k) { return { name: k, value: fields[k] }; });

        var payload = {
          fields: hsFields,
          context: { pageUri: window.location.href, pageName: document.title },
        };

        // Forms 2-4: non-marketing contacts (family members)
        if (formNumber > 1) {
          payload.legalConsentOptions = {
            consent: {
              consentToProcess: true,
              text: "Family member card",
              communications: []
            }
          };
          payload.marketingContactStatus = "NON_MARKETING";
        }

        console.log("Submitting to HubSpot form " + formNumber, fields);

        fetch(
          "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/" + formId,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        )
          .then(function (res) {
            if (!res.ok) {
              return res.text().then(function (t) { throw new Error(t); });
            }
            return res.json();
          })
          .then(function (data) {
            console.log("HubSpot submission success, form " + formNumber, data);
            if (onSuccess) onSuccess(data);
          })
          .catch(function (err) {
            console.error("HubSpot submission error, form " + formNumber, err);
            if (onError) onError(err);
          });
      }

      function formActions() {
        $(".card-loader-wrap").show();
        $("body").removeClass("OpenPopup");
        $(".popUpForm").hide();

        var step = getFormStep();
        if (!step || step === 0) {
          var tmp_data = JSON.stringify({
            email: $(".getEmail").val(),
            member_id: $("input[name=member_id_store]").val(),
          });
          localStorage.setItem("form_data", tmp_data);
        }
      }

      $(document).on("click", ".form-area .two-col-form-add-more-button", function () {
        var step = getFormStep();
        var formNumber = step + 1;
        var stored = getStoredFormData();
        var emailVal = stored ? stored.email : $(".getEmail").val();
        var memberVal = stored ? stored.member_id : $("input[name=member_id_store]").val();

        formActions();

        addToCart(function () {
          submitToHubSpot(
            formNumber,
            { email: emailVal, member_id: memberVal },
            function () {
              setTimeout(function () { location.reload(); }, 800);
            },
            function () {
              setTimeout(function () { location.reload(); }, 800);
            }
          );
        });
      });

      $(document).on("click", ".popUpFormWrap > .i-am-done > a", function () {
        var step = getFormStep();
        var formNumber = step + 1;
        var stored = getStoredFormData();
        var emailVal = stored ? stored.email : $(".getEmail").val();
        var memberVal = stored ? stored.member_id : $("input[name=member_id_store]").val();

        formActions();

        addToCart(function () {
          submitToHubSpot(
            formNumber,
            { email: emailVal, member_id: memberVal },
            function () {
              setTimeout(function () { window.location.href = "/cart"; }, 800);
            },
            function () {
              setTimeout(function () { window.location.href = "/cart"; }, 800);
            }
          );
        });
      });

      // ─── END HUBSPOT DIRECT API SUBMISSION ───────────────────────────────────

      // Card preview live update
      onKeyChangeCardText(".firstname", ".user-title");
      onKeyChangeCardText(".rescucitate", ".rescucitate-field");
      onKeyChangeCardText(".blood_type", ".blood-type-field");
      onKeyChangeCardText(".allergies", ".allergies-field");
      onKeyChangeCardText(".medications", ".medications-field");
      onKeyChangeCardText(".message", ".notes-field");
      onKeyChangeCardText(".contact_person_1_name", ".emergency-contact-one-name");
      onKeyChangeCardText(".relation_with_person", ".emergency-contact-one-relation");
      onKeyChangeCardText(".emergency_contact_person_1_number_user_1", ".emergency-contact-one-number");
      onKeyChangeCardText(".emergency_contact_person_2_name", ".emergency-contact-two-name");
      onKeyChangeCardText(".relation_with_person_2", ".emergency-contact-two-relation");
      onKeyChangeCardText(".emergency_contact_person_2_number", ".emergency-contact-two-number");

      function getCart() {
        setTimeout(function () { $(".card-loader-wrap").fadeOut(); }, 4000);

        jQuery.getJSON("/cart.js", function (cart) {
          let item = cart.items.find((x) => x.id === product_id);
          if (!item || item == null) {
            localStorage.removeItem("form_step");
            localStorage.removeItem("form_data");
          } else {
            localStorage.setItem("form_step", item.quantity);
            let tmp_local_storage = +localStorage.getItem("form_step");
            if (tmp_local_storage && tmp_local_storage > 0) {
              $(".formWrap").hide();
              switch (tmp_local_storage) {
                case 1:
                  $(".formTwo").show();
                  break;
                case 2:
                  $(".formThree").show();
                  break;
                case 3:
                  $(".formFour").show();
                  break;
                default:
                  $(".formWrap").hide();
                  break;
              }
            }
          }
          $(".card-loader-wrap").fadeOut();
        }).fail(function () {
          $(".card-loader-wrap").fadeOut();
        });
      }

      getCart();

      $(document).on("click", "#CartDrawer-Remove-1 button", function () {
        localStorage.removeItem("form_step");
        localStorage.removeItem("form_data");
        setTimeout(() => { location.reload(); }, 500);
      });

      $(document).on("click", ".closePopUp", function () {
        $(this).closest("body").removeClass("OpenPopup"),
          $(this).closest("body").find(".popUpForm").hide();
      });

      $(".quantity__button, .quantity__input")
        .attr("disabled", "disabled")
        .parent()
        .addClass("disableButtonsWrap")
        .append('<span class="cant-update">Can\'t Update</span>');

    }); // document ready
  }); // window load
}); // jQuery function ($)